<template>
  <section class="product-details-col product-details-desc">
    <header class="product-details-desc-header">
      <h3 class="text-uppercase text-m">
        {{description.header || header}}
      </h3>
      <h4 class="product-details-desc-status accent text-uppercase text-xs">
        <template v-if="status.length">
          <template v-for="(item, index) in status">
            <span v-if="checkStatus(item.values)" :key="'status-' + index">
              {{item.label}} {{item.values.join(', ')}}
            </span>
          </template>
        </template>
        <template v-else>
          &nbsp;
        </template>
      </h4>
      <h5 class="text-xs">
        {{description.subheader || '&nbsp;'}}
      </h5>
    </header>

    <template v-if="isPhone">
      <transition name="text">
        <TextSection
          :header="null"
          :description="description.text"
          :caption="null"
          :smaller="null"
          v-if="description.text"/>
      </transition>
    </template>
    <template v-else>
      <div class="product-details-desc-content text-m" v-if="description.text">
        {{ description.text }}
      </div>
    </template>

  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'productDescription',
  props: {
    description: {
      type: Object,
      default: function () {
        return {}
      }
    },
    header: String,
    status: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    checkStatus (values) {
      let retVal = false

      if (values.length) {
        if (values[0]) {
          retVal = true
        }
      }

      return retVal
    }
  },
  components: {
    TextSection
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  }
}
</script>

<style scoped lang="scss">
.product-details-desc {

  &-header {
    h3, h4, h5 {
      margin: 0 0 ($gap-xs / 2) 0;
    }
    h4 {
      font-weight: 500;
    }
    h5 {
      font-style: italic;
    }

  } // END .product-details-desc-header;

  &-content {
    font-weight: 500;
    margin: $gap-md 0;

    p, ul, ol, dl {
      font-weight: 500;
      margin: 0 0 $gap-sm 0;
    }
  } // END .product-details-desc-content;

  &-status {
    span {
      &:after {
        content: "|";
        display: inline-block;
        margin: 0 0.35em;
      }

      &:last-of-type:after {
        display: none;
      }
    }
  } // END .product-details-desc-status;

} // END .product-details-desc;

.separator-bar {
  margin: $gap-lg 0;
  text-align: left;

  svg {
    display: inline-block;
    height: auto;
    margin-right: $gap-xs;
    width: 24px;
  }

  .dark & {
    border-bottom: 3px solid $contrast-accent;

    svg {
      display: none;
    }
  }
}
</style>
